import {
    supportStatusCategories,
    supportRequestsTypes,
} from 'features/my-zone/support-requests/consts';

export const areSupportRequestsFiltered = (statusesCount: number, typesCount: number) => {
    if (
        (!statusesCount || statusesCount === Object.keys(supportStatusCategories).length) &&
        (!typesCount || typesCount === supportRequestsTypes.length)
    ) {
        return false;
    }

    return true;
};

export const convertSupportStatus = (status: string) => {
    if (supportStatusCategories.inProgress.includes(status)) {
        return 'In Progress';
    } else if (supportStatusCategories.completed.includes(status)) {
        return 'Completed';
    } else if (status === 'Pending') {
        return 'Pending Reply';
    }

    return status;
};

export const isDataTrustRequest = (supportTeam: string) => supportTeam === 'Data Quality';
